export default {
  props: {
    transport: { 
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    infoObj: {
      get() {
        return this.transport
      },
      set(val) {
        this.$emit('update:transport', val)
      }
    },
    totalDeviceCount () {
      return this.infoObj.leafNodes ? this.infoObj.leafNodes.length : 0
    },
    totalCheckedDevice () {
      return this.infoObj.leafNodes ? this.infoObj.leafNodes.filter(el => el.checked) : []
    }
  },
  methods: {
    /**
     * @description 递归更改当前层级及其子级对象的状态
     * @param {Object} item 当前层级对象
     * @param {Boolean} isCheck 是否勾选
     */
    changeItemStatus (item, isCheck) {
      item.checked = isCheck
      item.isIndeterminate = false
      let children = item.subList || item.nbhdDeviceInfo || item.value
      if (children && children.length) {
        for (let j = 0; j < children.length; j++) {
          this.changeItemStatus(children[j], isCheck)
        }
      }
    },
    checkChange () { // 该单元的某部电梯勾选状态变化时触发
      let { checked: preCheck,  isIndeterminate: preIndete } = this.infoObj // 保存之前的勾选和半选状态
      let leafNodes = this.infoObj.leafNodes
      let totalNo = leafNodes.length
      let checkedNo = leafNodes.filter(el => el.checked).length
      let nowCheck = checkedNo === totalNo
      let nowIndete = !!(checkedNo && checkedNo !== totalNo)
      // this.infoObj.checked = nowCheck
      // this.infoObj.isIndeterminate = nowIndete
      // 优化--checked和isIndeterminate属性只在各自发生变化时赋新值
      if (nowCheck !== preCheck) this.infoObj.checked = nowCheck
      if (nowIndete !== preIndete) this.infoObj.isIndeterminate = nowIndete
      this.$emit('check-change')
    }
  }
}
